import React from "react";
import { Box, Typography, Icon } from "@bca/ui-library";
import styled from "styled-components";

interface StarRatingProps {
  rating: string;
}

const StyledRating = styled(Box)`
  border-radius: 4px;
`;

const StarRating: React.FunctionComponent<StarRatingProps> = ({ rating }) => (
  <StyledRating
    display="flex"
    flexDirection="row"
    bg="#1D2948"
    width="44px"
    height="18px"
    alignItems="center"
    justifyContent="center"
  >
    <Icon name="star" weight="solid" color="white" width="12px" height="12px" />
    <Typography
      color="white"
      variant="label"
      my="0"
      ml="3px"
      fontSize={13}
      lineHeight="inherit"
    >
      {rating}
    </Typography>
  </StyledRating>
);

export default StarRating;
